import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';

export const snackbars = makeStyles<Theme>(({ spacing }) => ({
  container: {
    bottom: spacing(3)
  }
}));
